var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FieldGroupHeading"},[_c('h3',{class:_vm.isPrintPreview ? '' : 'showDottedLine'},[_c('span',[_vm._v(_vm._s(_vm.modelRow.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }